namespace Matrix.Data {
    export interface SecurityMatchRulesetRuleForm {
        Priority: Serenity.IntegerEditor;
        AutoReview: Serenity.BooleanEditor;
        Enabled: Serenity.BooleanEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class SecurityMatchRulesetRuleForm extends Serenity.PrefixedContext {
        static formKey = 'Data.SecurityMatchRulesetRule';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SecurityMatchRulesetRuleForm.init)  {
                SecurityMatchRulesetRuleForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.BooleanEditor;
                var w2 = StaticTextBlock;
                var w3 = ReadOnlyDateTime;

                Q.initFormType(SecurityMatchRulesetRuleForm, [
                    'Priority', w0,
                    'AutoReview', w1,
                    'Enabled', w1,
                    'CreatedBy', w2,
                    'CreatedWhen', w3,
                    'UpdatedBy', w2,
                    'UpdatedWhen', w3,
                    'Version', w2
                ]);
            }
        }
    }
}
